<template>
  <div class="mt-4">
    <div class="table-full-width table-responsive p-b-3 table-parent">
      <table v-if="timetable" class="table-journal">
        <thead>
          <tr>
            <th class="col-full-head"></th>
            <th class="cap-content" valign="bottom" v-for="(table, k) in timetable" :key="k">
              <div class="date-content">
                {{ table.date | dateDayMonth }}
              </div>
              <selector
                class="selector-nova"
                v-if="!holidays[table.date]"
                v-model="table.lessonplan"
                @input="setLessonplan(table, k)"
                :class="{'active': table.lessonplan}"
                :disableLabel="true"
                :prefix="`lessonplan_${table.id}`"
                :modal="`lessonplan`"
                :params="{
                  locale: group.locale,
                  discipline_id: discipline.id,
                  course_id: group.course.id,
                }"
                :selectKey="`title`"
              />
              <span v-if="!table.lessonplan" class="none-content">
                ...
              </span>
              <div v-else-if="holidays[table.date]">
                <h5>{{ holidays[table.date]["title"] }}</h5>
                <p>{{ holidays[table.date]["description"] }}</p>
              </div>
            </th>
            <!-- <th valign="bottom">
              <h5>Средний балл</h5>
            </th>
            <th valign="bottom">
              <h5>Итог</h5>
            </th> -->
          </tr>
        </thead>
        <tbody>
          <tr v-for="client in clients" :key="client.id"  class="table-journal-tr">
            <td class="col-full">
              <div class="face-content">
                <span class="_process" title="Итог">
                  <star-rating
                    v-model="client.process_result.value"
                    :star-size="17"
                    @rating-selected="updateRating(client)"
                  ></star-rating>
                </span>
                <span class="_rating" title="Средний балл">
                  <svg viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
                    <circle r="15" cx="15" cy="15" class="_circle-2"></circle>
                    <circle r="15" cx="15" cy="15" class="_circle-1"></circle>
                  </svg>
                  <b>{{ ratingAvg(client.ratings) }}</b>
                </span>
                <span class="_id">
                  <b>{{ client.id }}</b>
                </span>
                <span class="_name">
                  <span>
                    {{ client.full_name | maxChar(25) }}
                  </span>
                </span>
                <span class="_img hide">
                  <img :src="client.avatar">
                  <svg viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
                    <circle r="15" cx="15" cy="15" class="_circle-1"></circle>
                  </svg>
                </span>
              </div>
            </td>

            <td 
              :title="client.full_name"
              v-for="table in timetable"
              :key="table.id"
            >
         
                <ul :style="{background:red}" v-if="table.lessonplan" class="journal-control">
                  <li>
                    <attendance
                      v-model="client.timetable"
                      :client="client"
                      :table="table"
                    />
                  </li>
                  <li>
                    <ratings
                      :getJournal="getJournal"
                      v-model="client.ratings"
                      :client="client"
                      :table="table"
                    />
                  </li></ul
              >
            </td>
            <td :title="client.full_name">{{ ratingAvg(client.ratings) }}</td>
            <td :title="client.full_name">
              <star-rating
                v-model="client.process_result.value"
                :star-size="17"
                @rating-selected="updateRating(client)"
              ></star-rating>
            </td>
          </tr>
        </tbody>
      </table>
      <h5 v-else>Нет записей</h5>
    </div>
  </div>
</template>

<script>
import Attendance from "@/components/Progress/Journal/Attendance";
import Ratings from "@/components/Progress/Journal/Ratings.vue";

export default {
  components: {
    Attendance,
    Ratings,
  },
  created() {
  },
  data() {
    return {};
  },
  props: [
    "clients",
    "timetable",
    "group",
    "discipline",
    "part",
    "getJournal",
    "holidays",
  ],
  mounted(){
    // this.clients.push(this.clients[0])
    // setTimeout(() => {
    //   this.clients.push(this.clients[0]) 
    // }, 3);

    let mouseDown = false;
    let startX, scrollLeft;
    const slider = document.querySelector('.table-parent');

    const startDragging = (e) => {
      mouseDown = true;
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    }

    const stopDragging = (e) => {
      mouseDown = false;
    }

    const move = (e) => {
      e.preventDefault();
      if(!mouseDown) { return; }
      const x = e.pageX - slider.offsetLeft;
      const scroll = x - startX;
      slider.scrollLeft = scrollLeft - scroll;
    }

    // Add the event listeners
    slider.addEventListener('mousemove', move, false);
    slider.addEventListener('mousedown', startDragging, false);
    slider.addEventListener('mouseup', stopDragging, false);
    slider.addEventListener('mouseleave', stopDragging, false);
  },
  methods: {
    //установка планового урока
    setLessonplan(table, k) {
      this.$loading(true);
      this.$http
        .put(`business/timetables/${table.id}`, {
          lessonplan_id: table.lessonplan ? table.lessonplan.id : null,
        })
        .then((response) => {
          this.$set(this.timetable, k, response.data.data);
        })
        .catch((error) => {})
        .finally(() => {
          this.$loading(false);
        });
    },
    ratingAvg(ratings) {
      let count = ratings.length;
      let sum = 0;
      for (let i = 0; i < count; i++) {
        sum += ratings[i].value;
      }
      if (count > 0) return (sum / count).toFixed(1);
      return sum.toFixed(1);
    },
    updateRating(client) {
      this.$loading(true);
      this.$http
        .post(
          `business/progress/journal/groups/${this.group.id}/disciplines/${this.discipline.id}/parts/${this.part}`,
          { client_id: client.id, value: client.process_result.value }
        )
        .then((response) => {})
        .catch((error) => {})
        .finally(() => {
          this.$loading(false);
        });
    },
  },
};
</script>

